import styleConstants from './variables.module.scss';

export const otherColour = styleConstants.treemapColour0;
export const sideColours = [
    styleConstants.buyColour,
    styleConstants.sellColour,
    styleConstants.shortColour,
];
export const autoAssignedColours = [
    styleConstants.treemapColour1,
    styleConstants.treemapColour2,
    styleConstants.treemapColour3,
    styleConstants.treemapColour4,
    styleConstants.treemapColour5,
    styleConstants.treemapColour6,
    styleConstants.treemapColour7,
    styleConstants.treemapColour8,
    styleConstants.treemapColour9,
    styleConstants.treemapColour10,
];
export const colours = [otherColour, ...sideColours, ...autoAssignedColours];
export const otherColourIndex = 0;
export const buyColourIndex = 1;
export const sellColourIndex = 2;
export const shortColourIndex = 3;
export const autoColoursStartIndex = 4;

export function getAutoAssignedColourIndex(nodeIndex: number): number {
    return (nodeIndex % autoAssignedColours.length) + autoColoursStartIndex;
}

export function getLeafColour(colourIndex: number): string {
    return colours[colourIndex];
}
